import React from "react";
import { BASE_PATH } from "../../constants/awsBaseUrl";

const Captions = ({ type, translations, video, languages }) => {
  if (type === "live") return null;
  else if (translations?.length > 0)
    return (
      <>
        <track
          label="English"
          kind="captions"
          srcLang="en"
          src={`${BASE_PATH}/captions/${video}.vtt`}
        />
        {translations.map((keycode, index) => (
          <track
            key={index}
            label={languages.filter((lan) => lan.key == keycode)[0].language}
            kind="captions"
            srcLang={keycode}
            src={`${BASE_PATH}/captions-translated/${video}/${video}-${keycode}.vtt`}
          />
        ))}
      </>
    );
  else
    return (
      <track
        label="English"
        kind="captions"
        srcLang="en"
        src={`${BASE_PATH}/captions/${video}.vtt`}
      />
    );
};
export default Captions;
